

















import { PropType } from 'vue';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { AdgroupFormData } from '@tt4b/ttam-enums';
import { StateEnum, useAllowlist, useStore } from '@tt4b/ttam-hooks';
import { stringifyUrl } from 'query-string';

const name = 'ttam-brand-safety-center-compose';

export default defineComponent({
  name,
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props) {
    const { adgroupData } = toRefs(props);
    const { state, getStore } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
    const bscUrl = computed(() =>
      stringifyUrl({
        url: '/i18n/ttam_tools/bsc',
        query: {
          aadvid: aadvid.value,
          objective_type: adgroupData.value.objectiveType,
        },
      }),
    );
    const { isBrandSafetyCenterWhite } = useAllowlist();
    const { data: brandSafetyCenterInfo } = getStore(StateEnum.brandSafetyCenterInfo, undefined, false, false);
    const hasBscInfo = computed(() => Boolean(brandSafetyCenterInfo.value?.bscSettingId || ''));
    return {
      name,
      bscUrl,
      isBrandSafetyCenterWhite,
      hasBscInfo,
    };
  },
});
